module.exports = __webpack_public_path__ + "img/cabin-front.e35f22fe.webp";